<div class="position-relative" style="z-index: 999999 !important;">
  <div [ngStyle]="{ 'border-color': color + ' !important' }" class="position-absolute d-flex align-items-center justify-content-center" style="border: 3px dotted white; border-radius: 10px; width: 33vmin; height: 33vmin; transform: translate(-50%, -50%); top: 50%; left: 50%; opacity: 0.75">
    <h5 [ngStyle]="{ color: color }" class="font-weight-light text-center m-0 p-0">
      <span [innerHTML]="message"></span>
    </h5>
  </div>
  <zxing-scanner style="margin-bottom: -8px" (scanSuccess)="handleScanSuccess($event)"></zxing-scanner>
</div>
